import { resolveFleetCardViewModel } from "../utils/resultsFleetCardViewModel.js";

export default function useFleetCardViewModel(props) {
  return resolveFleetCardViewModel(props);
}
